import { addDaysToDate, calculateDaysDifference } from '@homeexchange/shared';
import i18n from '../i18n';
var formatExpirationDate = function (date) {
    var options = {
        weekday: 'long',
        month: 'long',
        day: 'numeric'
    };
    date.setHours(23, 59, 59);
    return date.toLocaleDateString(i18n.language, options);
};
export var getExpirationInformations = function (conversation, nbDaysPreapprovalExpiration) {
    var expirationDate = addDaysToDate(new Date(), nbDaysPreapprovalExpiration);
    var hasPreapprobationExpiration = !conversation.isMutual();
    var exchangeStartOn = new Date(conversation.getExchange().get('start_on'));
    var expirationDateIsAfterStartDate = expirationDate > exchangeStartOn;
    return {
        hasPreapprobationExpiration: hasPreapprobationExpiration,
        expirationDate: expirationDateIsAfterStartDate
            ? formatExpirationDate(exchangeStartOn)
            : formatExpirationDate(expirationDate),
        nbDays: expirationDateIsAfterStartDate
            ? calculateDaysDifference(new Date(), new Date(exchangeStartOn))
            : nbDaysPreapprovalExpiration
    };
};
